import { render } from "./CashMovements.vue?vue&type=template&id=e667420a"
import script from "./CashMovements.vue?vue&type=script&lang=js"
export * from "./CashMovements.vue?vue&type=script&lang=js"

import "./CashMovements.vue?vue&type=style&index=0&id=e667420a&lang=css"

import exportComponent from "/root/funtrain-administration/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__